import { FormatPage } from "@/components/FormatPage";
import { usePageTitle } from "@/lib/usePageTitle";

export default function Roundtables() {
  usePageTitle("Roundtables | Mentheris", "Small, curated sessions bringing decision-makers and researchers around a single transformation challenge.");
  return (
    <FormatPage
      testid="roundtables-page"
      titleTop="Round"
      titleAccent="tables."
      singleLine
      description="Small, curated sessions bringing together decision-makers and researchers around a single transformation challenge, designed for candour, not presentation decks."
      points={[
        { n: "01", title: "One challenge per session", text: "Each roundtable takes a single, concrete transformation challenge and stays with it until the room has genuinely worked it through." },
        { n: "02", title: "Candour by design", text: "Small groups, no recording, no decks. The format exists so that people can say what they actually observe, not what they are expected to present." },
        { n: "03", title: "From conversation to knowledge", text: "What emerges in the room is synthesised, anonymised, and feeds back into the Mentheris research programme and publications." },
      ]}
      cta="Interested in joining a future roundtable, or hosting one inside your organisation?"
    />
  );
}
